import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetMonthOverMonthChartRequestDtoSchema = z.object({
  type: z.enum(['alerts', 'flags']),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetMonthOverMonthChartResponseDtoSchema = z.object({
  changePcts: z.array(
    z.object({
      changePct: z.number(),
      period: z.string(),
    })
  ),
  counts: z.array(z.number()),
  drivers: z
    .array(
      z.array(
        z.object({
          alertType: z.string(),
          delta: z.number(),
          changePct: z.number().nullable(),
        })
      )
    )
    .default([]),
  labels: z.array(z.string()),
});

export type GetMonthOverMonthChartRequestDto = z.infer<
  typeof _GetMonthOverMonthChartRequestDtoSchema
>;
export type GetMonthOverMonthChartResponseDto = z.infer<
  typeof GetMonthOverMonthChartResponseDtoSchema
>;

export const getMonthOverMonthChart = (
  params: GetMonthOverMonthChartRequestDto,
  config?: AxiosRequestConfig<GetMonthOverMonthChartRequestDto>
) =>
  api
    .get('alerts/dashboard/month-over-month', { params, ...config })
    .then(responseContract(GetMonthOverMonthChartResponseDtoSchema));
